import React, { useEffect, useCallback, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  getDetailReclamation,
  getReclamationById,
} from "../../Redux/reclamationReduce";
import Configuration from "../../configuration";
import jwt_decode from "jwt-decode";
import { t } from "react-multi-lang";
function DetailsReclamation({ obj }) {
  const dispatch = useDispatch();
  const location = useParams();
  var idReclamation = location.id;
  var id = location.id;
  var token = localStorage.getItem("x-access-token");
  var decoded = jwt_decode(token);

  //input
  const [data, setData] = React.useState([]);
  const [reclamation, setReclamation] = React.useState({});
  const [loader, setLoader] = React.useState(true);

  /* detailReclamation */
  const detailReclamation = useCallback(async (idReclamation) => {
    var det = await dispatch(getDetailReclamation(idReclamation));
    var dataD = await det.payload.ligne;
    setData(dataD)
    setLoader(false)
    var dataReclamation = await dispatch(getReclamationById(idReclamation));
    var reclamationD = await dataReclamation.payload;
    setReclamation(reclamationD);
  }, [dispatch, idReclamation]);




  useEffect(() => {
    detailReclamation(idReclamation)
  }, [idReclamation, id]);



  return (
    <>

      {loader ? (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      ) : (
        ""
      )}
      {!loader ? (
        <Container fluid>
          <ToastContainer />
          <div className="section-image">
            <Row>
              <Col md="12">
                <Button
                  id="saveBL"
                  className="btn-wd btn-outline mr-1 float-left"
                  type="button"
                  variant="info"
                  onClick={() => {
                    window.history.back();
                  }}
                >
                  <span className="btn-label">
                    <i className="fas fa-list"></i>
                  </span>
                  {t('list')}
                </Button>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <Form action="" className="form" method="">
                  <Card>
                    <Card.Header>
                      <Card.Title as="h4">{t("claim_details")}</Card.Title>
                    </Card.Header>
                    <Card.Body>
                      <div>
                        {/* <table className="table table-bordered">
                          <thead>
                            <tr className="table-info">

                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                            
                            </tr>
                          </tbody>
                        </table>
                        <hr></hr> */}
                        {(reclamation.motif === 1 || reclamation.motif === 3) ? (
                          <table className="table table-bordered">
                            <thead>
                              <tr className="table-info">
                                {obj.user.id_role !== 6 && (<th>{t("Wholesaler")}</th>)}
                                <th>Date réclamation</th>
                                <th>Code Article</th>
                                <th>{t("article")}</th>
                                <th>{t("Reclamation.numero_lot")}</th>
                                <th>{t("reference_bl")}</th>
                                <th>Date expiration</th>
                                <th>{t("qte_reclame")}</th>
                                <th>{t("quantite")} du lot</th>
                                <th>{t("date_liv")}</th>
                                {reclamation.motif === 3 && <th>{t("Reclamation.type_claim")}</th>}
                                <th>{t("Motif")}</th>
                                <th>{t("commentaire")}</th>
                                <th>{t("attachment")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data.map((e) => (
                                <tr key={`ligne-${e.id}`}>
                                  {obj.user.id_role !== 6 && (<td>{reclamation.grossistes?.Raison_sociale || ""}</td>)}
                                  <td>{reclamation.createdAt ? new Date(reclamation.createdAt).toISOString().slice(0, 10) : ""}</td>
                                  <td>{reclamation.produits?.Code_article || ""}</td>
                                  <td>{reclamation.produits?.Designation_1 || ""}</td>
                                  <td>{reclamation.lot || ""}</td>
                                  <td>{e.numero_livraison || ""}</td>
                                  <td>{e.date_expiration || ""}</td>
                                  <td>{e.quantite || ""}</td>
                                  <td>{e.quantite_livraison || ""}</td>
                                  <td>{e.Date_expedition || ""}</td>
                                  {reclamation.motif === 3 && <td>{reclamation.types?.nom || ""}</td>}
                                  <td>{reclamation.motif_description || ""}</td>
                                  <td>{e.commentaire || ""}</td>
                                  <td>
                                    {reclamation.filename && (
                                      <a
                                        className="btn btn-info"
                                        download={reclamation.filename}
                                        href={`${Configuration.BACK_BASEURL}reclamation/${reclamation.filename}`}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        <i className="fas fa-download"></i> {t("download")}
                                      </a>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        ) : (
                          <table className="table table-bordered">
                            <thead>
                              <tr className="table-info">
                                {obj.user.id_role !== 6 && (<th>{t("Wholesaler")}</th>)}
                                <th>Date réclamation</th>
                                <th>{t("Motif")}</th>
                                <th>Description de la réclamation</th>
                                <th>{t("attachment")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {console.log(obj)}
                              <tr key={`ligne-${reclamation.id}`}>
                                {obj.user.id_role !== 6 && (<td>{reclamation.grossistes?.Raison_sociale || ""}</td>)}
                                <td>{reclamation.createdAt ? new Date(reclamation.createdAt).toISOString().slice(0, 10) : ""}</td>

                                <td>{reclamation.motif_description || ""}</td>
                                <td>{reclamation.commentaire || ""}</td>
                                <td>
                                  {reclamation.filename && (
                                    <a
                                      className="btn btn-info"
                                      download={reclamation.filename}
                                      href={`${Configuration.BACK_BASEURL}reclamation/${reclamation.filename}`}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <i className="fas fa-download"></i> {t("download")}
                                    </a>
                                  )}
                                </td>
                              </tr>

                            </tbody>
                          </table>
                          // <div
                          //   style={{
                          //     border: "1px solid #ccc",
                          //     padding: "10px",
                          //     borderRadius: "5px",
                          //     marginTop: "10px",
                          //   }}
                          // >
                          //   <Card.Title as="h4">{t("claim_description")}</Card.Title>
                          //   <div
                          //     style={{
                          //       padding: "10px",
                          //       borderRadius: "5px",
                          //       marginTop: "50px",
                          //       fontSize: "16px",
                          //     }}
                          //   >
                          //     {reclamation.commentaire}
                          //   </div>
                          // </div>
                        )}

                      </div>
                      <div className="clearfix"></div>
                    </Card.Body>
                  </Card>
                </Form>
              </Col>
            </Row>
          </div>
        </Container>
      ) : (
        ""
      )}
    </>
  );
}

export default DetailsReclamation;
